module.exports = __webpack_public_path__ + "static/img/naturalCircle6h.f6446fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle6h.svg
// module id = NugD
// module chunks = 1